import React from "react";
import { StyleSheet, Text, View } from "react-native";

import { Spacings } from "@/styling/spacings";
import { themes } from "@/Components/Styling/themeConfigs";
import { EXPLORE_CONSTANTS } from "@/utils/explore";
import {
  Interest,
  UserInterestAttributeSet,
} from "@/schemas/profile/attributes/UserInterestAttributeSet";

type Props = {
  interests: Interest[];
  isLargeCard?: boolean;
};

function CommonInterests({
  interests,
  isLargeCard = false,
}: Props): React.JSX.Element {
  if (!interests || interests.length === 0) {
    return <></>;
  }

  return (
    <View
      style={[
        styles.container,
        isLargeCard
          ? styles.largeProfileContainer
          : styles.smallProfileContainer,
      ]}
    >
      {interests
        .slice(
          0,
          isLargeCard
            ? EXPLORE_CONSTANTS.MAX_INTERESTS_DISPLAY_HORIZONTAL
            : EXPLORE_CONSTANTS.MAX_INTERESTS_DISPLAY_VERTICAL,
        )
        .map((interestId) => UserInterestAttributeSet.map[interestId])
        .filter((interest) => interest !== undefined)
        .sort((a, b) => a.label.length - b.label.length) // Sort by label length (shortest first)
        .map((interest, index) => (
          <View key={`${interest.id}-${index}`}>
            <Text
              style={[
                styles.interestTag,
                {
                  fontSize: isLargeCard
                    ? currentTheme.typography.body.size.mobile
                    : currentTheme.typography.body.size.mobile - 2,
                },
              ]}
            >
              {interest.iconLabel} {interest.label}
            </Text>
          </View>
        ))}
      {/* Conditionally render "+ X More" */}
      {interests.length >
        (isLargeCard
          ? EXPLORE_CONSTANTS.MAX_INTERESTS_DISPLAY_HORIZONTAL
          : EXPLORE_CONSTANTS.MAX_INTERESTS_DISPLAY_VERTICAL) && (
        <View key={`more-interests`}>
          <Text
            style={[
              styles.interestTag,
              {
                fontSize: isLargeCard
                  ? currentTheme.typography.body.size.mobile
                  : currentTheme.typography.body.size.mobile - 2,
              },
            ]}
          >
            +{" "}
            {interests.length -
              (isLargeCard
                ? EXPLORE_CONSTANTS.MAX_INTERESTS_DISPLAY_HORIZONTAL
                : EXPLORE_CONSTANTS.MAX_INTERESTS_DISPLAY_VERTICAL)}{" "}
            More
          </Text>
        </View>
      )}
    </View>
  );
}

const currentTheme = themes.morning;

const styles = StyleSheet.create({
  container: {
    alignItems: "flex-start",
    marginVertical: Spacings.s1,
  },
  largeProfileContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
  },
  smallProfileContainer: {
    flexDirection: "column",
    position: "absolute",
    bottom: 24,
  },
  interestTag: {
    color: "#eeeeee",
    backgroundColor: "rgba(85, 85, 85, 0.75)",
    borderRadius: 5,
    padding: Spacings.s1,
    margin: Spacings.s1 / 2,
  },
});

export default CommonInterests;
